import React from "react";
import { useState, useEffect } from 'react';
import { fetchWithAuth } from "../../auth"
import AddMailDest from "../../dialogs/addMailDest"
import ModifyMailDest from "../../dialogs/modifyMailDest"

import '../../index.css';

const MailDestTableDB = ({
    serial
}) => {
    const [mysqlMailDestState, setMysqlMailDestState] = useState([]);

    async function fetchmaildest() {
        await fetchWithAuth('/maildest/' + serial, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                setMysqlMailDestState(data)
            })
    }

    useEffect(() => {
        fetchmaildest()
    }, [serial]);

    async function deleteDest(event) {
        let _id = event.target.getAttribute('id_arg');
        await fetchWithAuth('/maildest', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: _id })
        })
    }

    const [openAddMailDest, setOpenAddMailDest] = useState(false);
    const handleCloseAddMailDest = () => {
        setOpenAddMailDest(false)
    };
    const handleOpenAddMailDest = () => {
        setOpenAddMailDest(true)
    };

    const [openModifyMailDest, setOpenModifyMailDest] = useState(false);
    const [modifyMailDestId, setModifyMailDestId] = useState();
    const [modifyMailDestCurrentAddress, setModifyMailDestCurrentAddress] = useState('');
    const handleCloseModifyMailDest = () => {
        setOpenModifyMailDest(false)
    };
    const handleOpenModifyMailDest = (event) => {
        setModifyMailDestId(event.target.getAttribute('id_arg'))
        setModifyMailDestCurrentAddress(event.target.getAttribute('address_arg'))
        setOpenModifyMailDest(true)
    };

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <AddMailDest isOpen={ openAddMailDest } onClose = { handleCloseAddMailDest } gw = {serial} />
            <ModifyMailDest isOpen={ openModifyMailDest } onClose = { handleCloseModifyMailDest } id = {modifyMailDestId} currentAddress = {modifyMailDestCurrentAddress}/>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px', backgroundColor: 'yellow', color: 'black', fontWeight: 'bold' }}>
                {isOpen ? 'Nascondi MailDest' : 'Mostra MailDest'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle_db_user" colSpan="2">Destinatari e-mail</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
                        </tr>
                        <tr>
                            <th className="title">indirizzo</th>
                            <th className="title">tipo destinatario</th>
                            <th style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={handleOpenAddMailDest}>Aggiungi</button>
                                <button onClick={fetchmaildest}>Aggiorna</button>
                            </th>
                        </tr>
                        {mysqlMailDestState.map(mapMailDest => (
                            <tr key={mapMailDest.id}>
                                <td>{mapMailDest.address}</td>
                                <td>{mapMailDest.type}</td>
                                <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                    <button onClick={deleteDest} id_arg={mapMailDest.id}>elimina</button>
                                    <button onClick={handleOpenModifyMailDest} id_arg={mapMailDest.id} address_arg={mapMailDest.address}>modifica</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default MailDestTableDB;
